import { render } from "./DialogPersonal.vue?vue&type=template&id=6a5a21aa&scoped=true"
const script = {}

import "./DialogPersonal.vue?vue&type=style&index=0&id=6a5a21aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5a21aa"]])

export default __exports__